import { useMemo, useState } from 'react';
export function useToggleModules(modules = []) {
    const [openedModules, setOpenedModules] = useState({});
    const allModulesAreOpen = useMemo(() => {
        if (!modules.length)
            return false;
        return modules.every((module) => openedModules[module.id]);
    }, [modules, openedModules]);
    function toggleAllModules() {
        const newState = modules.reduce((acc, module) => {
            return { ...acc, [module.id]: !allModulesAreOpen };
        }, {});
        setOpenedModules(newState);
    }
    function toggleModule(moduleId, open) {
        setOpenedModules((prev) => ({
            ...prev,
            [moduleId]: open ?? !prev[moduleId]
        }));
    }
    return {
        openedModules,
        allModulesAreOpen,
        toggleModule,
        toggleAllModules
    };
}
